export const getBasename = () => {
  const { CURRENT_LANGUAGE, location } = window
  const pathFirstSegment = location.pathname.split('/')[1]

  return CURRENT_LANGUAGE === 'en' && pathFirstSegment !== 'en'
    ? '/v-editor'
    : `/${CURRENT_LANGUAGE}/v-editor`
}
